import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const DesignationForm = (props) => {

  const options = Array.from({ length: 15 }, (_, index) => index + 1);
  const [level, setLevel] = useState('');
  const [designationName, setDesignationName] = useState("");
  const [designationData, setDesignationData] = useState([]);

  const { sendRequest: getDesignationData } = useHttp();

  const { sendRequest: postDesignationDetails } = useHttp();


  const FillDetail = () => {
    getDesignationData(
      {
        url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setDesignationData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDesignationData]);


  const submitHandler = (e) => {
    e.preventDefault();
    if (!props.update) {
      const isExistingDesignation = designationData.some(
        (designation) => designation.designationName === designationName
      );

      if (isExistingDesignation) {
        toast.error("designation name already exists");
        return;
      }
    }
    const data = {
        level: level,
        designationName: designationName.trim(),
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        serviceId: props.sId,
    };
    
    console.log(data);

    if(props.update) {
        data["designationId"] = props.update.designationId;
      }

    postDesignationDetails(
      {
        url: "/api/designation/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(`Designation Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
        
      },
      (error) => {
        toast.error(error || "Something went wrong");
        console.log(error);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      setLevel(props.update.level);
      setDesignationName(props.update.designationName);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Designation Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Level</label>
                        <select
                          id="level"
                          className="form-control"
                          required
                          value={level}
                          onChange={(e) => {
                            setLevel(e.target.value);
                          }}
                        >
                          <option value="">Select Level</option>
                          {options.map((option) => (
                            <option key={option} value={option}>
                                level {option}
                            </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Designation name</label>
                        <input
                          type={"text"}
                          id={"designationName"}
                          required
                          className="form-control"
                          value={designationName}
                          onChange={(e) => {
                            setDesignationName(e.target.value);
                        }}
                        />
                      </div>
                    </div>

                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default DesignationForm;
